import React, { useEffect } from "react";
import { Box, Button } from "@sainsburys-tech/fable";
import Headerfile from "../common/Headerfile";
import Styles from "./Login.module.css";
import userManager from "../../utils/userManager";

const LoginNew = () => {
  useEffect(() => {
    setTimeout(() => {
      localStorage.clear();
    }, 1000);
  }, []);

  const handleSSOLogin = () => {
    try {
      userManager
        .signinRedirect()
        .then(() => {
          console.log("Success");
        })
        .catch((err) => {
          console.log(err, "Error");
        });
    } catch (err) {
      console.log(err, "Error");
    }
  };

  return (
    <div className={Styles.container}>
      <Headerfile />
      <Box as="div" className={Styles.boxContainer}>
        <div className="App">
          <span className={Styles.firstSpan}>Welcome To SmartPrint!</span>
          <br />
          <br />
          <span className={Styles.secondSpan}>
            Please click on <strong>Continue</strong> to proceed...
          </span>
          <Button
            type="submit"
            style={{ width: "100%" }}
            className="my-5"
            onClick={() => handleSSOLogin()}
          >
            Continue
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default LoginNew;
